module.exports = __webpack_public_path__ + "img/stock-photo.c4f5b01b.jpg";